

jQuery(document).ready(function() {
  $('.open_sizeChart_js').on('click', function (e) { 
    e.preventDefault();
    $('body').toggleClass("sizeChart__active");
  });

  $('.swatch-element').on('click', function () {
    var data_id = $(this).attr("data-id");
    $("select#ProductSelect-product-template option[value='"+data_id+"']").prop('selected', true).trigger('change');
    var data_price = $(this).attr('data-price');
    $('.product-single__meta span').html(data_price);

    var var_this = $(this).closest('.prod_info_Box');
    var current_qty_shop = Number($(var_this).find(".prod_quantity_input_js").attr("data-qty"));
    var current_qty_fast_cart = 0;
    if ( $(".fast_cart_item[data-variant_id='"+data_id+"']").length > 0 ) {
      $(".fast_cart_item[data-variant_id='"+data_id+"']").each( function () {
        current_qty_fast_cart = current_qty_fast_cart + Number($(this).attr("data-qty")); 
      });
    }

    if ($(this).hasClass('soldout') || current_qty_shop == current_qty_fast_cart) {
      $('.product_form_submit button').prop('disabled', true);
      $('.product_form_submit button').attr('data-variant-id', data_id);
      $('#AddToCartText-product-template').html('Sold out');
    } else {
      $('.product_form_submit button').prop('disabled', false);
      $('#AddToCartText-product-template').html('Add to cart');
    }

    var container = $(this).closest('.swatch');
    $(container).find('.header').html($(this).attr('data-value'));
    $(container).find('input').removeAttr('checked');
    $(this).find('input').prop('checked', 'checked');
  });
  
  $('body').on('click', function (e) {
    if ($(e.target).closest('.fast_cart_all.fast_cart_all_js').length === 0 && $(e.target).closest(".header_info_cart").length === 0) {
      $('.fast_cart_position').removeClass('cart-drawer_open');
      $('body').removeClass('js-drawer-open');
    }

    if ($(e.target).closest('.pop_up_sizeChart_box').length === 0 && $(e.target).closest('.open_sizeChart_js').length === 0) {
      $('body').removeClass("sizeChart__active");
    }
  });

  $('.cart-drawer').on('click', function () {
    $('.fast_cart_position').addClass('cart-drawer_open');
    $('body').addClass('js-drawer-open');
  });

  $('.cart-back-btn').on('click', function () {
      $('.fast_cart_position').removeClass('cart-drawer_open');
      $('body').removeClass('js-drawer-open');
  });

  $('.cart-remove-line-item-btn').on('click', function () {
    var id = $(this).attr('data-variant-id');
    jQuery.ajax({
      url: '/cart/change.js',
      type: 'post',
      dataType: 'json',
      data: {
        id: id,
        quantity: 0
      },
      success: function(response) {
        var open_fast_cart = true;
        $('.product_form_submit button[data-variant-id="' + id + '"]').prop('disabled', false); 
        $('.product_form_submit button[data-variant-id="' + id + '"] #AddToCartText-product-template').html('Add to cart');
        fast_cart_hard_update (open_fast_cart);
      }
    });
  });

  $('.js-qty__adjust--plus').on('click', function () {
    var id = $(this).attr('data-variant-id');
    var container = $(this).closest('.js-qty__wrapper');
    var qty = $(container).find('.js-qty__num').val();
    qty++;

    jQuery.ajax({
      url: '/cart/change.js',
      type: 'post',
      dataType: 'json',
      data: {
        id: id,
        quantity: qty
      },
      success: function(response) {
        var open_fast_cart = true;
        fast_cart_hard_update (open_fast_cart);
      }
    });
  });

  $('.js-qty__adjust--minus').on('click', function () {
    var id = $(this).attr('data-variant-id');
    var container = $(this).closest('.js-qty__wrapper');
    var qty = $(container).find('.js-qty__num').val();
    qty--;
    if (qty < 0) {
      qty = 0;
    }

    jQuery.ajax({
      url: '/cart/change.js',
      type: 'post',
      dataType: 'json',
      data: {
        id: id,
        quantity: qty
      },
      success: function(response) {
        var open_fast_cart = true;
        $('.product_form_submit button[data-variant-id="' + id + '"]').prop('disabled', false); 
        $('.product_form_submit button[data-variant-id="' + id + '"] #AddToCartText-product-template').html('Add to cart');
        fast_cart_hard_update (open_fast_cart);
      }
    });
  });

  Array.prototype.slice.call(document.getElementsByClassName('fix-ls')).forEach(removeLastCharLetterSpacing);



  function wrapInSpan(node, className) {
    // Create span
    var span = document.createElement("span");
    span.classList.add(className);
  
    // Insert span before node
    node.parentNode.insertBefore(span, node);
  
    // Move node inside span
    span.appendChild(node);
  }
  
  function insertSpanClassForLastVisibleChar(node, className) {
    if (!node) return;
    if (node.textContent.length > 1) {
      // Split and wrap
      var lastCharIndex;
      var matchWhitespaceAtEnd = node.textContent.match(/[ \t\n]+$/);
      if (matchWhitespaceAtEnd && matchWhitespaceAtEnd.index > 0) {
        lastCharIndex = matchWhitespaceAtEnd.index - 1;
      } else {
        lastCharIndex = node.textContent.length - 1;
      }
  
      var lastCharNode = node.splitText(lastCharIndex);
      wrapInSpan(lastCharNode, className);
    } else if (node.textContent.length === 1) {
      // Wrap
      wrapInSpan(node, className);
    }
  }
  
  function getLastNodeMatch(el, fnMatch, fnSkip, inRecursion) {
    function getMatch(el) {
      if (!fnSkip || !fnSkip(el)) {
        return getLastNodeMatch(el, fnMatch, fnSkip, true);
      }
      return null;
    }
  
    if (fnMatch(el)) return el;
    var match;
    if (el.hasChildNodes()) {
      for (var i=el.childNodes.length-1; i>=0; i--) {
        match = getMatch(el.childNodes[i]);
        if (match) return match;
      }
    }
    if (inRecursion) {
      if (el.previousSibling) {
        match = getMatch(el.previousSibling);
        if (match) return match;
      }
      if (el.parentNode.previousSibling) {
        match = getMatch(el.parentNode.previousSibling);
        if (match) return match;
      }
    }
    return null;
  }
  
  function getLastTextNodeDeep(el) {
    return getLastNodeMatch(
      el,
      function match(node) {
        return (node.nodeType === 3 && node.textContent.match(/[^ \t\n]/));
      },
      function skip(node) {
        return (node.nodeName === "svg");
      }
    );
  }
  
  function removeLastCharLetterSpacing(el) {
    if (el.querySelector("no-ls")) return; // Class already found in el, nothing to do
    insertSpanClassForLastVisibleChar(getLastTextNodeDeep(el), 'no-ls');
  }
  



/*
==============================================
==============================================
         C A R T   A J A X
==============================================
==============================================
*/


/*
==============================================
         COLLECTION ADD CART
==============================================
*/
$("body").on('submit', 'form.coll_form_js', function(e) { 
  var var_this = $(this);
  var check_qty_cart_ajax = Number($(".header_info_num.total_qty_js").html());


  e.preventDefault();
  var go_work = true;
  if ( $("body").hasClass("coll_Ajax_work") ) {
    var go_work = false;
  }

  if (go_work) {
    fastCart.item_id = var_this.attr('data-variant_id');

    $("body").addClass("coll_Ajax_work");
    var_this.parents(".coll_product_item").addClass("active_1");
    var_this.parents(".cart_item").addClass("active_1");
    var data_serialize = $(this).serialize();


    /* check qty - Error */
    var qty_error = true;

    if ( $(".fast_cart_item[data-variant_id='"+var_this.attr('data-variant_id')+"']").length > 0 ) {

      var fast_cart_item__qty = 0;
      $(".fast_cart_item[data-variant_id='"+var_this.attr('data-variant_id')+"']").each( function () {
        fast_cart_item__qty = fast_cart_item__qty + Number( $(this).attr('data-qty') );
      });
      if ( fast_cart_item__qty >= Number(var_this.attr('data-quantity')) ) {
        var data_quantity = var_this.attr('data-quantity');
        var data_v_title = var_this.parents(".coll_product_item").find(".grid-view-item__title").text();
        var_this.append("<div class='coll_prod_Ajax_error'>All " + data_quantity + " " + data_v_title + " are in your cart.</div>");


        qty_error = false;
      }
    }


    /* OPEN FAST CART no ajax */
    if (qty_error) {
      var itemAdd_var_id = var_this.attr('data-variant_id');
      var itemAdd_prod_id = var_this.attr('data-prod_id');
      var itemAdd_qty = 1;
      var itemAdd_qty_MAX = var_this.attr('data-quantity');
      var itemAdd_price = var_this.attr('data-price');
        //var itemAdd_priceSale = var_this.attr('data-price_sale');
        var itemAdd_priceSale = "";
        var itemAdd_title = var_this.parents(".coll_product_item").find(".grid-view-item__title").text();
        var itemAdd_image = var_this.parents(".coll_product_item").find(".coll_form_js").attr("data-fastCart");
        var itemAdd_article = '';
        var itemAdd_info = '';
        var itemAdd_url = var_this.attr('data-url');
        addCart_fastSimple (itemAdd_var_id,itemAdd_prod_id,itemAdd_qty,itemAdd_qty_MAX,itemAdd_price,itemAdd_priceSale,itemAdd_title,itemAdd_image,itemAdd_article,itemAdd_info,itemAdd_url);

        var total_qty = Number($(".total_qty_js").html()) + 1;
        $(".total_qty_js").html(total_qty);
        $(".total_qty_js").attr('data-count', total_qty);

        var_this.parents(".coll_product_item").addClass("active_2");
        var_this.parents(".cart_item").addClass("active_2");
        $('.quickview_all').fadeOut();
        setTimeout(function () { $('.quickview_all').remove(); }.bind(this), 1000);
      }

      jQuery.ajax({
        url: '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: data_serialize,
        success: function(response) {
          if ( $("body").hasClass("template-cart") ) {
            if ( check_qty_cart_ajax == 0 ) {
              location.reload();
            } else {
              cart_page__update_all ( '/cart' );
            }
          } 

          setTimeout(function() {
            $("body").removeClass("coll_Ajax_work"); 

            var_this.parents(".coll_product_item").removeClass("active_1");
            var_this.parents(".coll_product_item").removeClass("active_2");
            var_this.parents(".cart_item").removeClass("active_1");
            var_this.parents(".cart_item").removeClass("active_2");
          }, 2000); 

          var open_fast_cart = false;
          fast_cart_hard_update (open_fast_cart);
        },
        error: function(xhr,status,error){
          // console.log(xhr);
          // console.log(status);
          // console.log(error);

          setTimeout(function() {
            $("body").removeClass("coll_Ajax_work");

            var_this.parents(".coll_product_item").removeClass("active_1");
            var_this.parents(".coll_product_item").removeClass("active_2");
            var_this.parents(".cart_item").removeClass("active_1");
            var_this.parents(".cart_item").removeClass("active_2");
            var_this.find(".coll_prod_Ajax_error").remove();
          }, 2500); 
        }
      });

    } /* go_work */
  }); /* submit  */



function addCart_fastSimple (itemAdd_var_id,itemAdd_prod_id,itemAdd_qty,itemAdd_qty_MAX,itemAdd_price,itemAdd_priceSale,itemAdd_title,itemAdd_image,itemAdd_article,itemAdd_info,itemAdd_url) {

  jQuery('.fast_cart_position').html( localStorage.getItem('ls_fast_drawer_cart_all_js') );

  if ( $(".fast_cart_item[data-variant_id='"+itemAdd_var_id+"']").length == 0 ) {
    var var_itemAdd_priceSale = '';
    if ( itemAdd_priceSale != "NaN" && itemAdd_priceSale != "" ) {
      var_itemAdd_priceSale = '<div class="cart-item__original-price"><s>'+theme.Currency.formatMoney(itemAdd_priceSale, theme.moneyFormat)+'</s></div>';
    }
    var var_itemAdd_price = itemAdd_price * itemAdd_qty;

    fastCart.item_html = '<div class="fast_cart_item" data-variant_id="'+itemAdd_var_id+'" data-qty="'+itemAdd_qty+'">'+
    '<div class="fast_cart_item_image">'+
    '<a href="'+itemAdd_url+'"><img src="'+itemAdd_image+'" alt="" data-item-url="'+itemAdd_url+'"></a>'+
    '</div>'+
    '<div class="fast_cart_item_info">'+
    '<div class="fast_cart_item_title"><a href="'+itemAdd_url+'">'+itemAdd_title+'</a></div>'+
    '<div class="fast_cart_item_price">'+
    var_itemAdd_priceSale +
    '<div class="cart_line_price_total">'+
    theme.Currency.formatMoney(var_itemAdd_price, theme.moneyFormat) +
    '</div>'+
    '</div>'+
    '<div class="fast_cart_item_info_list">'+
    '</div>'+
    '</div>'+
    '<button class="cart-remove-line-item-btn" data-variant-id="'+itemAdd_var_id+'"><svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><g fill="#000" fill-rule="nonzero"><path d="M2.343 15.071L.93 13.657 13.657.929l1.414 1.414z"></path><path d="M.929 2.343L2.343.93l12.728 12.728-1.414 1.414z"></path></g></svg></button>' + 
    '</div>';

    if ( fastCart.item_html != false ) {
      $(".fast_cart_items.prod_carousel_css").prepend(fastCart.item_html);
      fastCart.item_html = false;  
    }   
  }


  var total_fastCart_price = Number($(".fast_cart_totalPrice_js").attr("data-price")) + ( itemAdd_qty * itemAdd_price );
  $(".fast_cart_totalPrice_js").html( theme.Currency.formatMoney(total_fastCart_price, theme.moneyFormat) );
  $(".fast_cart_totalPrice_js").attr("data-price", total_fastCart_price);
  
  localStorage.setItem('ls_fast_drawer_cart_all_js', jQuery('.fast_cart_position').html() );

  $("body").addClass("open_fast_cart__fixed_hover");
  $('.fast_cart_full_show').show();
  $('.fast_cart_empty_show').hide();
  fast_cart_slider_init ();
  setTimeout(function() {
    $("body").removeClass("open_fast_cart__fixed_hover");
  }, 4000);
  
} 


/*
==============================================
         PRODUCT + -
==============================================
*/
/* MINUS  */
$("body").on("click", ".prod_quantity_minus_js", function () {
  $(".prod_Quantity_item").removeClass("prod_quantity_disable");
  var data_num = Number($(this).parents(".prod_Quantity_items").find(".prod_Quantity_item_input").val());
  data_num = data_num - 1;
  if ( data_num < 1) {
    data_num = 1;
  }
  $(this).parents(".prod_Quantity_items").find(".prod_Quantity_item_input").val(data_num);
});
/*  PLUS  */
$("body").on("click", ".prod_quantity_plus_js", function () {
  $(".prod_Quantity_item").removeClass("prod_quantity_disable");
  var max_qty = $(this).parents(".product_form_js").find(".prod_quantity_input_js").attr("data-qty"); 

  var data_num = Number($(this).parents(".prod_Quantity_items").find(".prod_Quantity_item_input").val());
  data_num = data_num + 1;
  if ( data_num >= max_qty ) {
    data_num = max_qty;
    $(".prod_quantity_plus_js").addClass("prod_quantity_disable");
  }
  if ( data_num < 1 ) {
    data_num = 1;
  }
  $(this).parents(".prod_Quantity_items").find(".prod_Quantity_item_input").val(data_num)
});

/*
==============================================
        PRODUCT ADD CART
==============================================
*/
$("body").on('submit', 'form.product_form_js', function(e) { 
  e.preventDefault();
  var var_this = $(this);
  var go_work = true;

  // scroll mob
  /*
  if ( $(document).width() < 1024 ) { 
    var var_scrollTop_pos =  $(".prod_error_js_pos_2").offset().top - 35;
    setTimeout(function() { $('html, body').animate({ scrollTop: var_scrollTop_pos }, 500); }, 50);
  } else if ( $(".prod_error_t:not(.prod_good_t)").length > 0 ) {
    var var_scrollTop_pos =  $(".prod_error_js_pos_2").offset().top - 75;
    setTimeout(function() { $('html, body').animate({ scrollTop: var_scrollTop_pos }, 500); }, 50);
  }
  */
  
  if ( $("body").hasClass("coll_Ajax_work") ) {
    go_work = false;
    return false;
  }
  /* CHECK SELECTs  */
  $(".prod_options_js__select").each( function () {
    if ( $(this).val() == "no_select" ) {
      $(this).find("+ .prod_options_js__select_error").slideDown();
      go_work = false;
      return false;
    }
  });



  if (go_work) {
    var qty_error = true;
    fastCart.item_id = var_this.find("#ProductSelect-product-template option:selected").attr("value");


    $("body").addClass("coll_Ajax_work");
    var data_variant_id = Number(var_this.find("select.prod_var_qty_js").val()); 
    var current_qty_input = Number(var_this.find(".prod_quantity_input_js").val());
    var current_qty_shop = Number(var_this.find(".prod_quantity_input_js").attr("data-qty"));
    var current_qty_fast_cart = 0;
    if ( $(".fast_cart_item[data-variant_id='"+data_variant_id+"']").length > 0 ) {
      $(".fast_cart_item[data-variant_id='"+data_variant_id+"']").each( function () {
        current_qty_fast_cart = current_qty_fast_cart + Number($(this).attr("data-qty")); 
      });
    }
    if ( current_qty_shop == current_qty_fast_cart ) {
      /* ERROR */
      $(".prod_error_box").html('<span class="prod_error_icon"></span><span class="prod_error_t">UNFORTUNATELY THE QUANTITY YOU CHOSE EXCEEDED THE MAXIMUM ORDER QUANTITY FOR THIS PRODUCT. THE QUANTITY IN YOUR SHOPPING BAG HAS BEEN REDUCED TO THE MAXIMUM ORDER QUANTITY.</span>');
      setTimeout(function() { $(".prod_error_js").slideDown(); }, 10);
      qty_error = false;

      /* scroll to error*/
      /*
      if ( $(".prod_error_js_pos_2").offset().top < $(window).scrollTop() && $(document).width() >= 1024) {
        var var_scrollTop_pos =  $(".prod_error_js_pos_2").offset().top - 45;
        setTimeout(function() { $('html, body').animate({ scrollTop: var_scrollTop_pos }, 500); }, 50);
      }
      */

      $('.product_form_submit button').prop('disabled', true);
      $('.product_form_submit button').attr('data-variant-id', data_variant_id);
      $('#AddToCartText-product-template').html('Sold out');

      return false;
    } 
    var current_qty_available_now = current_qty_shop - current_qty_fast_cart;
    if ( current_qty_available_now < current_qty_input ) {
      current_qty_input = current_qty_available_now;
      var_this.find(".prod_quantity_input_js").val(current_qty_input);
      $(".prod_Quantity_item").removeClass("prod_quantity_disable");
    } 


    /* GOOD TEXT INFO */ 
    // $(".prod_error_box").html('<span class="prod_good_icon"></span><span class="prod_error_t prod_good_t"><span>Quantity Added</span> '+current_qty_input+'</span>');
    // setTimeout(function() { $(".prod_error_js").slideDown(); }, 10);

    var_this.addClass("active_1");
    var data_serialize = $(this).serialize();



    /* OPEN FAST CART no ajax */
    if (qty_error) {
      var itemAdd_var_id = var_this.find("#ProductSelect-product-template option:selected").attr("value"); 
      var itemAdd_prod_id = var_this.find("#ProductSelect-product-template").attr("data-prod_id");
      var itemAdd_qty = var_this.find(".prod_quantity_input_js").val();
      var itemAdd_qty_MAX = var_this.find("#ProductSelect-product-template option:selected").attr("data-qty");
      var itemAdd_price = var_this.parents(".product_flex_all").find(".price-item--regular").attr("data-price"); 
      //var itemAdd_priceSale = var_this.parents(".product_flex_all").find(".price-item--regular").attr("data-price-sale"); 
      var itemAdd_priceSale = ""; 
      var itemAdd_title = var_this.parents(".product_flex_all").find("h1.product_title").text();
      var itemAdd_image = var_this.find("#ProductSelect-product-template").attr("data-fastCartImg");
      var itemAdd_article = '';
      var itemAdd_info = '';
      var itemAdd_url = '';   // 11111111111111


      addCart_fastSimple (itemAdd_var_id,itemAdd_prod_id,itemAdd_qty,itemAdd_qty_MAX,itemAdd_price,itemAdd_priceSale,itemAdd_title,itemAdd_image,itemAdd_article,itemAdd_info,itemAdd_url);

      //var total_qty = Number($(".total_qty_js").html()) + 1;
      //$(".total_qty_js").html(total_qty);

      var_this.parents(".coll_product_item").addClass("active_2");
      var_this.parents(".cart_item").addClass("active_2");
      $('.quickview_all').fadeOut();
      setTimeout(function () { $('.quickview_all').remove(); }.bind(this), 1000);
    }


    /* header qty */
    var total_qty = Number($(".total_qty_js").html()) + current_qty_input;
    $(".total_qty_js").html(total_qty);
    $(".total_qty_js").attr('data-count', total_qty);


    /* AJAX  */
    jQuery.ajax({
      url: '/cart/add.js',
      type: 'post',
      dataType: 'json',
      data: data_serialize,
      success: function(response) {
        var_this.addClass("active_2");
        $('.quickview_all').fadeOut();
        setTimeout(function () { $('.quickview_all').remove(); }.bind(this), 1000);
        //$("body").removeClass("coll_Ajax_work"); 
        setTimeout(function() {
          var_this.removeClass("active_1");
          var_this.removeClass("active_2");
        }, 2000);     

        var open_fast_cart = true;
        fast_cart_hard_update (open_fast_cart);

        $('.fast_cart_position').addClass('cart-drawer_open');
        $('body').addClass('js-drawer-open');
      },
      error: function(xhr,status,error) {
        //$("body").removeClass("coll_Ajax_work");
        //console.log(xhr);
        //console.log(status);
        //console.log(error);

        var data_quantity = var_this.attr('data-quantity');
        var data_v_title = var_this.attr('data-v_title');
        var_this.append("<div class='coll_prod_Ajax_error'>All " + data_quantity + " " + data_v_title + " are in your cart.</div>");

        setTimeout(function() {
          var_this.removeClass("active_1");
          var_this.removeClass("active_2");
          var_this.remove();
        }, 3000); 
        fast_cart_hard_update ();
      }
    });
  } /* go_work */

}); // submit



/*
==============================================
       FAST CART OPEN
==============================================
*/
/* DATA localStorage */
var fast_drawer_cart_all_js = $(".fast_cart_position").html();
localStorage.setItem('ls_fast_drawer_cart_all_js', fast_drawer_cart_all_js);

/* HOVER */
// $(".header_info_cart, .fast_cart_position").hover(function () {
//   if ( !$(".header_info_cart").hasClass("open") && !$("body").hasClass("open_fast_cart__fixed_hover") ) {
//     var this_Position_Left = $(this).offset().left + $(this).width();
//     var this_Position_Top = $(this).offset().top + $(this).height();
//     var this_width = $(this).width();

//     $(".header_info_cart").addClass("open");
//     jQuery('.fast_cart_position').html( localStorage.getItem('ls_fast_drawer_cart_all_js') );  
//     fast_cart_slider_init ();
//     $(".total_qty_js").html( $(".fast_cart_goCart .total_qty_js").html() );
//   } 
// }, function () {
//   $(".header_info_cart").removeClass("open");
// });
/* FIXED */
$(".fast_cart_position").hover(function () {
  if ( $("body").hasClass("open_fast_cart__fixed") ) {
    //$("body").addClass("open_fast_cart__fixed_hover");
  } else {
    //$("body").removeClass("open_fast_cart__fixed_hover");
  }
}, function () {
  //$("body").removeClass("open_fast_cart__fixed_hover");
});


/*
==============================================
        FAST CART HARD UPDATE
==============================================
*/
function fast_cart_hard_update (open_fast_cart) {

  jQuery.ajax({
    url: '/cart?view=minicart',
    dataType: 'html',
    complete: function (data) {    
      jQuery('.fast_cart_position').html( data.responseText ); 
      var fast_drawer_cart_all_js = $(".fast_cart_position").html();
      localStorage.setItem('ls_fast_drawer_cart_all_js', fast_drawer_cart_all_js);
      $(".total_qty_js").html( $(".fast_cart_goCart .total_qty_js").html() );
      $(".total_qty_js").attr('data-count', $(".fast_cart_goCart .total_qty_js").html());

      // fast_cart_slider_init ();
      /* open fast cart */
      if (open_fast_cart) {
        setTimeout(function() {
          $("body").addClass("open_fast_cart__fixed");
        }, 100);
        setTimeout(function() {
          $("body").removeClass("open_fast_cart__fixed");
        }, 4000);
      }

      $("body").removeClass("coll_Ajax_work");

      $('.cart-back-btn').on('click', function () {
        $('.fast_cart_position').removeClass('cart-drawer_open');
        $('body').removeClass('js-drawer-open');
      });

      $('.cart-remove-line-item-btn').on('click', function () {
        var id = $(this).attr('data-variant-id');
        //console.log(id);
        jQuery.ajax({
          url: '/cart/change.js',
          type: 'post',
          dataType: 'json',
          data: {
            id: id,
            quantity: 0
          },
          success: function(response) {
            var open_fast_cart = true;
            $('.product_form_submit button[data-variant-id="' + id + '"]').prop('disabled', false); 
            $('.product_form_submit button[data-variant-id="' + id + '"] #AddToCartText-product-template').html('Add to cart');
            fast_cart_hard_update (open_fast_cart);
          }
        });
      });

      $('.js-qty__adjust--plus').on('click', function () {
        var id = $(this).attr('data-variant-id');
        var container = $(this).closest('.js-qty__wrapper');
        var qty = $(container).find('.js-qty__num').val();
        qty++;
    
        jQuery.ajax({
          url: '/cart/change.js',
          type: 'post',
          dataType: 'json',
          data: {
            id: id,
            quantity: qty
          },
          success: function(response) {
            var open_fast_cart = true;
            fast_cart_hard_update (open_fast_cart);
          }
        });
      });
    
      $('.js-qty__adjust--minus').on('click', function () {
        var id = $(this).attr('data-variant-id');
        var container = $(this).closest('.js-qty__wrapper');
        var qty = $(container).find('.js-qty__num').val();
        qty--;
        if (qty < 0) {
          qty = 0;
        }
    
        jQuery.ajax({
          url: '/cart/change.js',
          type: 'post',
          dataType: 'json',
          data: {
            id: id,
            quantity: qty
          },
          success: function(response) {
            var open_fast_cart = true;
            $('.product_form_submit button[data-variant-id="' + id + '"]').prop('disabled', false); 
            $('.product_form_submit button[data-variant-id="' + id + '"] #AddToCartText-product-template').html('Add to cart');
            fast_cart_hard_update (open_fast_cart);
          }
        });
      });

      //func_update_total_price ();
      //func_update_total_qty ();
      //func_update__line_num ();
      //currency_Update_ll ();
    }
  });
}
/*
function func_update_total_price () {
  var total_price = 0;
  var this_qty ;
  $(".fast_cart_items .fast_cart_item").each( function()  { 
    this_qty = Number( $(this).attr("data-qty") );
    total_price = total_price + ( Number( $(this).attr("data-price") ) * this_qty );
  });
  if ( $(".total_price_js").length > 0 ) {
    $(".drawer_cart_subtotal").html("<span class='theme-money'>"+Shopify.formatMoney(total_price,theme.money_format)+"</span>");
  }
};
function func_update_total_qty () { 
// item_count
    var total_qty = 0;
    $(".fast_cart_items").first().find(".fast_cart_item").each( function()  { 
        total_qty = total_qty + Number( $(this).attr("data-qty") );
    });
    if ( total_qty > 0 ) {
        $(".cart-count__text").html("("+total_qty+")");
        $('.cart-summary.header_right_item').attr("data-cart_count",total_qty); 
    } else {
        $(".cart-count__text").html("(0)");
        $('.cart-summary.header_right_item').attr("data-cart_count", 0); 
    }
};
function func_update__line_num () { 
  $(".fast_cart_items").each( function()  { 
    var i = 1;
    $(this).find(".fast_cart_item").each( function()  { 
      $(this).attr("data-line", i);
      i++;
    });
  });
  $(".cart_drawer_info").html( $(".cart_drawer_info_js_fix").html() );
};
*/







// PRODUCT
$('.prod_quantity_input_js').on("keydown", function(event) {
  return ValidateNumericInput(event);
});
$('.prod_quantity_input_js').change(function() {
  $(".prod_Quantity_item").removeClass("prod_quantity_disable");
  var data_qty = Number($(".prod_quantity_input_js").attr("data-qty"));
  var data_num = Number($(this).val());
  if ( data_num > data_qty ) {
    $(this).val(data_qty);
    $(".prod_quantity_plus_js").addClass("prod_quantity_disable");
  }
});
// CART
$('body').on("keydown", '.cart_Quantity_item_input', function(event) {
  return ValidateNumericInput(event);
});
$('body').on('change', '.cart_Quantity_item_input', function() {
  $(this).parents(".cart_item").find(".cart_Quantity_item").removeClass("cart_quantity_disable");
  var data_qty = Number($(this).attr("data-qty"));
  var data_num = Number($(this).val());
  if ( data_num == 0 ) {
    data_num = 1;
    $(this).val(data_num);
  }
  if ( data_num == 1 ) {
    $(this).parents(".cart_item").find(".cart_quantity_minus_js").addClass("cart_quantity_disable");
    $(this).parents(".cart_item").find(".cart_item_info__price").slideUp();
  } else {
    $(this).parents(".cart_item").find(".cart_item_info__price").slideDown();
  }
  if ( data_num > data_qty ) {
    data_num = data_qty;
    $(this).val(data_qty);
    $(this).parents(".cart_item").find(".cart_quantity_plus_js").addClass("cart_quantity_disable");
  }
  
  var line = $(this).parents(".cart_item").attr("data-line");
  var data_url = "/cart/change?line="+line+"&quantity="+data_num+""; 
  cart_page__update_all ( data_url );
});

//**********************************************
// ValidateNumericInput
// usage: from html input form: onkeydown="return ValidateNumericInput(event.keyCode)"
//**********************************************
function ValidateNumericInput(objEvent) {
  if (objEvent.altKey || objEvent.ctrlKey ||  objEvent.shiftKey)  {
    return false;
  }
  var nKeyCode = objEvent.keyCode;
  // allow 0 through 9 on regular keyboard
  if ((nKeyCode >= 48) && (nKeyCode <= 57)) return true;
  // allow 0 through 9 on keypad
  if ((nKeyCode >= 96) && (nKeyCode <= 105)) return true;
  // allow backspace
  if (nKeyCode == 8) return true;
  // allow delete key
  if (nKeyCode == 46) return true;
  // allow tab key
  if (nKeyCode == 9) return true;
  // allow shift key
  if (nKeyCode == 16) return true;
  return false;
}



/*
==============================================
        fast_cart_slider_init
==============================================
*/
function fast_cart_slider_init () {

  if ( fastCart.item_id != false ) {
    var this_data_html = $(".fast_cart_item[data-variant_id='"+fastCart.item_id+"']").first().parent().html();
    $(".fast_cart_item[data-variant_id='"+fastCart.item_id+"']").first().parent().remove();
    
    if ( $("body").hasClass("ar_lang") ) {
    	$(".fast_cart_items.prod_carousel_css").append(this_data_html);
    } else {
    	$(".fast_cart_items.prod_carousel_css").prepend(this_data_html);
    }
  }

  // $('.fast_cart_items').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   dots: false,
  //   centerMode: true,
  //   focusOnSelect: true,
  //   infinite: false,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  // });
}
fast_cart_slider_init ();







/*
==============================================
==============================================
          CART PAGE - AJAX
==============================================
==============================================
*/

/*
==============================================
          CART PAGE - delete
==============================================
*/
$("body").on("click", ".cart_item_remove_a", function (e) {
  e.preventDefault();

  var var_this = $(this);

  var_this.parents(".cart_item").slideUp(400);
  
  setTimeout(function() { 
    var_this.parents(".cart_item").remove();
    cart_page__fastSimple_update () 
  }, 410);

  var data_url = var_this.attr("href");

  if ( $(".cart_item_remove_a").length === 1 ) {
    window.location = data_url;
    $("body").fadeOut(1500);
  } else {
    cart_page__update_all ( data_url );
  }
});
/*
==============================================
          CART PAGE - update all page ajax
==============================================
*/
function cart_page__update_all ( data_url ) {

  cart_page__fastSimple_update ();

  if ( typeof data_url == "undefined" ) {
    var data_url = '/cart';
  }
  jQuery.ajax({
    url: data_url,
    dataType: 'html',
    complete: function (data) {    
      var fast_drawer_cart_all_js = jQuery(".fast_cart_position", data.responseText).html();
      localStorage.setItem('ls_fast_drawer_cart_all_js', fast_drawer_cart_all_js);
      jQuery('.fast_cart_position').html(fast_drawer_cart_all_js); 

      $(".total_qty_js").html( jQuery(".header_info_num.total_qty_js", data.responseText).html() );
      $(".total_qty_js").attr('data-count', jQuery(".header_info_num.total_qty_js", data.responseText).html());

      $(".cart_items").html( jQuery(".cart_flex_all .cart_items", data.responseText).html() );

      $(".cart_subtotal_money").html( jQuery(".cart_subtotal_money", data.responseText).html() );
      $(".cart_subtotal.cart_total").html( jQuery(".cart_subtotal.cart_total", data.responseText).html() );

      setTimeout(function() { fast_cart_slider_init (); }, 10);
    }
  });
}
function cart_page__fastSimple_update () {
  var globalTotal_price = 0;
  $(".cart_flex_all .cart_item").each( function () {
    var data_price = Number($(this).attr('data-price'));
    var data_num = Number($(this).find(".cart_quantity_input").val());

    var total_price = data_price * data_num;
    $(this).find(".cart_line_price_total").html(theme.Currency.formatMoney(total_price, theme.moneyFormat));
    globalTotal_price = globalTotal_price + total_price;
  });
  $(".cart_subtotal_money").html(theme.Currency.formatMoney(globalTotal_price, theme.moneyFormat));
  $(".cart_subtotal_price").html(theme.Currency.formatMoney(globalTotal_price, theme.moneyFormat));

}

/*
==============================================
         CART + -
==============================================
*/
/* MINUS  */
$("body").on("click", ".cart_quantity_minus_js:not(.cart_quantity_disable)", function () {
  $(this).parents(".cart_item").find(".cart_Quantity_item").removeClass("cart_quantity_disable");
  var data_num = Number($(this).parents(".cart_Quantity_items").find(".cart_Quantity_item_input").val());
  data_num = data_num - 1;
  if ( data_num < 1) {
    data_num = 1;
  }
  if ( data_num == 1 ) {
    $(this).parents(".cart_item").find(".cart_quantity_minus_js").addClass("cart_quantity_disable");
    $(this).parents(".cart_item").find(".cart_item_info__price").slideUp();
  } else {
    $(this).parents(".cart_item").find(".cart_item_info__price").slideDown();
  }
  $(this).parents(".cart_Quantity_items").find(".cart_Quantity_item_input").val(data_num);

  var line =$(this).parents(".cart_item").attr("data-line");
  var data_url = "/cart/change?line="+line+"&quantity="+data_num+"";
  cart_page__update_all ( data_url );
});
/*  PLUS  */
$("body").on("click", ".cart_quantity_plus_js:not(.cart_quantity_disable)", function () {
  $(this).parents(".cart_item").find(".cart_Quantity_item").removeClass("cart_quantity_disable");
  var max_qty = $(this).parents(".cart_item").find(".cart_Quantity_item_input").attr("data-qty"); 

  var data_num = Number($(this).parents(".cart_Quantity_items").find(".cart_Quantity_item_input").val());
  data_num = data_num + 1;
  if ( data_num >= max_qty ) {
    data_num = max_qty;
    $(this).parents(".cart_item").find(".cart_quantity_plus_js").addClass("cart_quantity_disable");
  }
  if ( data_num == 1 ) {
    $(this).parents(".cart_item").find(".cart_item_info__price").slideUp();
  } else {
    $(this).parents(".cart_item").find(".cart_item_info__price").slideDown();
  }
  $(this).parents(".cart_Quantity_items").find(".cart_Quantity_item_input").val(data_num);

  var line =$(this).parents(".cart_item").attr("data-line");
  var data_url = "/cart/change?line="+line+"&quantity="+data_num+"";
  cart_page__update_all ( data_url );
});







/*
==============================================
         CART STICKY SUBTOTAL
==============================================
*/
$("body").on("click", ".cart_sticky_button_js", function (e) {
  e.preventDefault();
  setTimeout(function() { 
    var top_animate = $(".cart_flex_all").offset().top - 80;
    $('html, body').animate({ scrollTop: top_animate }, 750); 
  }, 50);
});
$(window).scroll(function() {
  if ( $(".cart_info_submit").length > 0 ) {
    var winPos = $(window).scrollTop();
    var buttonPos = $('.cart_info_submit').offset().top + 100;

    if ( winPos > buttonPos ) {
      $(".cart_sticky_total_all").addClass("active");
      setTimeout(function() { 
        var cart_sticky_total_all_height = $(".cart_sticky_total_all").outerHeight();
        $("body").css("padding-bottom", cart_sticky_total_all_height ) ;
      }, 510);
    } else {
      $(".cart_sticky_total_all").removeClass("active");
      setTimeout(function() { $("body").css("padding-bottom", 0 ) }, 510);
    }
  }
});



/*
==============================================
         CART GIFT
==============================================
*/
$("body").on("click", ".cart_AddGiftBag_item", function (e) { 
  if ( $(this).hasClass("active") ) {
    $(this).removeClass("active");
    if ( $(this).attr("data-item") == "FreeGiftBag" ) {
      $("li.cart_info_gifts__FreeGiftBag").removeClass("active");
      localStorage.setItem('cart_info_gifts__FreeGiftBag', "false");
      $("input.attributes__FreeGiftBag").val("NO");
    }
    if ( $(this).attr("data-item") == "FreeGreetingCard" ) {
      $("li.cart_info_gifts__FreeGreetingCard").removeClass("active");
      localStorage.setItem('cart_info_gifts__FreeGreetingCard', "false");
      $("input.attributes__FreeGreetingCard").val("NO");
      // text
      $(".cart_Greeting_Card_text").slideUp();
      $(".cart_Greeting_Card_text_js").val('');
    }
  } else {
    $(this).addClass("active");
    if ( $(this).attr("data-item") == "FreeGiftBag" ) {
      $("li.cart_info_gifts__FreeGiftBag").addClass("active");
      localStorage.setItem('cart_info_gifts__FreeGiftBag', "true");
      $("input.attributes__FreeGiftBag").val("YES");
    }
    if ( $(this).attr("data-item") == "FreeGreetingCard" ) {
      $("li.cart_info_gifts__FreeGreetingCard").addClass("active");
      localStorage.setItem('cart_info_gifts__FreeGreetingCard', "true");
      $("input.attributes__FreeGreetingCard").val("YES");
      // text
      $(".cart_Greeting_Card_text").slideDown();
      $(".cart_Greeting_Card_text_js").val( localStorage.getItem('cart_info_gifts__FreeGreetingCard_Text') );
    } 
  }
});

function cart_AddGiftBag_Check () {
  if ( Number($(".header_info_num.total_qty_js").html()) == 0 ) {
    localStorage.setItem('cart_info_gifts__FreeGiftBag', "false");
    localStorage.setItem('cart_info_gifts__FreeGreetingCard', "false");
  }
  if ( localStorage.getItem('cart_info_gifts__FreeGiftBag') == "true" ) {
    $("li.cart_info_gifts__FreeGiftBag").addClass("active");
    $(".cart_AddGiftBag_item[data-item='FreeGiftBag']").addClass("active");
    $("input.attributes__FreeGiftBag").val("YES");
  }
  if ( localStorage.getItem('cart_info_gifts__FreeGreetingCard') == "true" ) {
    $("li.cart_info_gifts__FreeGreetingCard").addClass("active");
    $(".cart_AddGiftBag_item[data-item='FreeGreetingCard']").addClass("active");
    $("input.attributes__FreeGreetingCard").val("YES"); 

    // text
    $(".cart_Greeting_Card_text_js").val( localStorage.getItem('cart_info_gifts__FreeGreetingCard_Text') );
    if ( localStorage.getItem('cart_info_gifts__FreeGreetingCard_Text') != null ) { 
      $('.contact_form_NumWords_js').html( 350 - localStorage.getItem('cart_info_gifts__FreeGreetingCard_Text').length );
      if ( localStorage.getItem('cart_info_gifts__FreeGreetingCard_Text').length == 350 ) {
        $('.contact_form_NumWords_js').html( 350 );
        $(".contact_form_item_js_2 .contact_form__error_1000").show();
      }
    }
    $(".cart_Greeting_Card_text").show();
  } else {
    localStorage.setItem('cart_info_gifts__FreeGreetingCard_Text', '');
  }

}
cart_AddGiftBag_Check ();





//
//  TEXT
// 

$("#cart_Greeting_Card_text_ID").on("keydown", function(event) {
  contactForm_error_textarea ($(this));
});
$("#cart_Greeting_Card_text_ID").on("keyup", function(event) {
  contactForm_error_textarea ($(this));
});
$("#cart_Greeting_Card_text_ID").on("click", function(event) {
  contactForm_error_textarea ($(this));
});

function contactForm_error_textarea (var_this) {
  var box = var_this.val();
  var count = 350 - box.length;

  $('.contact_form_NumWords_js').html(count);

  if(box.length >= 350) {
    /* ERROR */
    var_this.parents(".contact_form_item_js").find(".contact_form__error_1000").show();
    var_this.parents(".contact_form_item_js").find(".contact_form__error:not(.contact_form__error_1000)").hide();
    //var_this.parents(".contact_form_item_js").addClass("error_this");
    $('.contact_form_NumWords_js').html(350);
    var_this.val( box.substring(0, 350) );
  } else {
    var_this.parents(".contact_form_item_js").find(".contact_form__error_1000").hide();
    //var_this.parents(".contact_form_item_js").removeClass("error_this");
  }

  localStorage.setItem('cart_info_gifts__FreeGreetingCard_Text', var_this.val() );
};






/*
==============================================
         LANDING POPUP 
==============================================
*/
$("body").on("click", ".landing_PopUp_link", function () {
  if ( !$("body").hasClass("landing_PopUp_open") ) {
    $("body").addClass("landing_PopUp_open");
    var data_id = $(this).attr("data-id");
    $("body").append('<div class="landing_PopUp_js"></div>')
    $(".landing_PopUp_all[data-id="+data_id+"]").clone().appendTo(".landing_PopUp_js");

    var prod_carousel_items_js_autoplay = false;
    if ( $('.prod_carousel_items_js___1').attr('data-autoplay') == 'true' ) {
      prod_carousel_items_js_autoplay = true;
    }
    $(".landing_PopUp_js .landing_PopUp_all .landing_PopUp_carousel").slick({
      dots: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: prod_carousel_items_js_autoplay,
      autoplaySpeed: $(".landing_PopUp_js .landing_PopUp_all .landing_PopUp_carousel").attr('data-autoplaySpeed'),
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 370,
        settings: {
          slidesToShow: 1
        } 
      }
      ]
    });
    $('.prod_carousel_items').each( function() {
      //console.log($(this).find('.prod_carousel_item').length);
      $(this).attr('data-qty', $(this).find('.prod_carousel_item').length );
    }); 

    $(".landing_PopUp_js .landing_PopUp_all").css("top", 0) 
    

  }
});
$("body").on("click", ".landing_PopUp_close", function () {
  $(".landing_PopUp_js .landing_PopUp_all").css("top", "100%"); 

  setTimeout(function() {
    $("body").removeClass("landing_PopUp_open");
    $(".landing_PopUp_js").remove();
  }, 500);

});




/*
==============================================
         SELECT COUNTRY POPUP
==============================================
*/
$("body").on("click", ".selectCountry_PopUp_link", function () { 
  if ( !$("body").hasClass("selectCountry_PopUp_open") ) {
    $("body").addClass("selectCountry_PopUp_open");
    $(".selectCountry_PopUp_hide").show();
    setTimeout(function() {
      $(".selectCountry_PopUp_all").css("top", 0) ;
    }, 1);
  }
});
$("body").on("click", ".selectCountry_PopUp_close", function () {
  $(".selectCountry_PopUp_js .selectCountry_PopUp_all").css("top", "100%"); 

  setTimeout(function() {
    $("body").removeClass("selectCountry_PopUp_open");
    $(".selectCountry_PopUp_hide").hide();
  }, 500);

});








/*
==============================================
         LANDING VIDEO
==============================================
*/
$("body").on('click', '.landing_video_box__image_icon', function() {
  var var_this = $(this);
  var data_url = $(this).attr('data-video_url');

  if ( !$(this).parents(".landing_video_box").find(".landing_video_iframe").hasClass("ready") ) {
    $(this).parents(".landing_video_box").find(".landing_video_iframe").attr('src', 'https://www.youtube.com/embed/'+data_url+'?rel=0&amp;showinfo=0&autoplay=0');
  }

  var_this.parents(".landing_video_box").addClass("this_show")

});
function landing_video_box_preload () {
  $(".landing_video_box__image_icon").each( function () {
    var var_this = $(this);
    var data_url = $(this).attr('data-video_url');
    $(this).parents(".landing_video_box").find(".landing_video_iframe").attr('src', 'https://www.youtube.com/embed/'+data_url+'?rel=0&amp;showinfo=0&autoplay=0');
    $(this).parents(".landing_video_box").find(".landing_video_iframe").addClass("ready");

  });
}
setTimeout(function() { landing_video_box_preload () }, 2500);









/*
==============================================
         ARROW SCROLL TOP
==============================================
*/
function arrow_scroll_top () {
  var top_show = 150; 
  var delay = 500; 
  $(document).ready(function() {
    $(window).scroll(function () { 
      if ($(this).scrollTop() > top_show) $('.arrow_scroll_top').fadeIn(250);
      else $('.arrow_scroll_top').fadeOut();
    });
    $('.arrow_scroll_top').click(function () {
      $('body, html').animate({
        scrollTop: 0
      }, delay);
    }); 
  });
}
arrow_scroll_top ();








/*
==============================================
         HEADER STICKY
==============================================
*/


var header_sticky__navPos, header_sticky__winPos, header_sticky__navHeight;
var header_sticky__start = false;
setTimeout(function() { header_sticky__start = true; }, 2100);

function header_sticky__refreshVar() {
  $('.header_sticky_height').removeClass('fixed');
  $('body').removeClass('header_sticky'); 
  $('.header_sticky_height').removeAttr("style");
  header_sticky__navHeight = $('.header_sticky_height').outerHeight(true);
  header_sticky__navPos = $('.header_sticky_height').offset().top + header_sticky__navHeight + 2;
  $('.anouncement__slider_all').removeClass("ready");


  var var_header_sticky_height = $('.header_sticky_height').height();
  setTimeout(function() { $('.header_sticky_height').height( var_header_sticky_height ) }, 10);
  setTimeout(function() { $('.anouncement__slider_all').addClass("ready"); }, 20);

  setTimeout(function() { header_sticky__start = true; }, 500);
} 


setTimeout(function() { header_sticky__refreshVar(); }, 2000);
setTimeout(function() { header_sticky__refreshVar(); }, 5000);



var width = $(window).width(); 
$(window).resize(function() {
    if ($(window).width()== width) return; 
    width = $(window).width();
    if (header_sticky__start) {
      header_sticky__refreshVar ();
    }
});


$(window).scroll(function() {
  if (header_sticky__start) {
    header_sticky__winPos = $(window).scrollTop();

    if (header_sticky__winPos >= header_sticky__navPos) {
      $('body').addClass('header_sticky'); 
      $('.header_sticky_height').addClass('fixed'); 
    }  
    else {
      $('.header_sticky_height').removeClass('fixed');
      $('body').removeClass('header_sticky'); 
      $('.search_form__menu_js').removeAttr("style"); 
      $('body').removeClass('header_searchPopup_fixed'); 
      $('.search_form__menu_js').focusout()
      

      //$('.header_sticky_height').removeAttr("style");
      //setTimeout(function() { $('.header_sticky_height').height( $('.header_sticky_height').height() ) }, 10);
    }
    // main_menu_width ();
  }

  if ( $('.header_sticky_height').height() <  ( $('#shopify-section-header_announcement_bar').height() + $('.header_sticky_relative').height() ) ) {
    header_sticky__refreshVar(); 
  }

});

$('.search__input_js').focus( function() {
  search_page_fix_searchPopup () ;
});
$('.search__input_js').on('keyup input', function() {
  search_page_fix_searchPopup () ;
});
function search_page_fix_searchPopup () {
  if ( $(window).width() >= 768 ) {
    let top = '328px';

    if ( $(window).width() <= 1024 ) {
      top = '255px';
    }
    setTimeout(function () {
      $('.boost-pfs-search-suggestion-column-2-non-fullwidth:not(.boost-pfs-search-suggestion-mobile)').css('top', top);
    }.bind(this), 50);
    setTimeout(function () {
      $('.boost-pfs-search-suggestion-column-2-non-fullwidth:not(.boost-pfs-search-suggestion-mobile)').css('top', top);
    }.bind(this), 100);
    setTimeout(function () {
      $('.boost-pfs-search-suggestion-column-2-non-fullwidth:not(.boost-pfs-search-suggestion-mobile)').css('top', top);
    }.bind(this), 1000);
    setTimeout(function () {
      $('.boost-pfs-search-suggestion-column-2-non-fullwidth:not(.boost-pfs-search-suggestion-mobile)').css('top', top);
    }.bind(this), 2000);
    setTimeout(function () {
      $('.boost-pfs-search-suggestion-column-2-non-fullwidth:not(.boost-pfs-search-suggestion-mobile)').css('top', top);
    }.bind(this), 3000);
  }
}



//
// HOVER MENU - BLACK-WHITE HEADER
//
$(document).ready(function () {
  var logo_white = $('.img_main_logo').attr('data-white');
  var logo_black = $('.img_main_logo').attr('data-black');

  $( ".header_white_true .main_menu_item_li" ).mouseover(function() {
      $('.header_sticky_height').removeClass('header_sticky__white');
      $('.header_sticky_height').addClass('header_sticky__white_hover');
      $('.img_main_logo').attr('src', logo_black);
  }).mouseout(function() {
    $('.header_sticky_height').removeClass('header_sticky__white_hover');
    $('.header_sticky_height').addClass('header_sticky__white');
    $('.img_main_logo').attr('src', logo_white);
  });
});
 
// deley show menu
$(document).ready(function () {
  $('.main_menu_all').on('mouseenter', function(){
    $('.main_menu_layer').addClass('hover_1');
    setTimeout(function () {
      if ( $('.main_menu_layer').hasClass('hover_1') ) {
        $('.main_menu_layer').addClass('hover_2');
      } 
    }.bind(this), 200);
  }).on('mouseleave', function(){
    $('.main_menu_layer').removeClass('hover_1');
    $('.main_menu_layer').removeClass('hover_2');
  });
});


/*
==============================================
         HEADER STICKY - SEARCH
==============================================
*/
$("body").on("click", ".header_search_sticky_button_js", function() {
    $(".search_form__menu_js").fadeToggle();
    $('body').toggleClass('header_searchPopup_fixed'); 
});






// ===============================================================
// ========================  MAIN MENU CLOSE  =============================
// ===============================================================
$("body").on("click", ".main_menu_Close_js", function () {
  $(".main_menu_lvl_2_all").addClass("hide");
  setTimeout(function() { $(".main_menu_lvl_2_all").removeClass("hide"); }, 50);

});


// ===============================================================
// ========================  MAIN MENU WIDTH  =============================
// ===============================================================
function main_menu_width () { 
  if ( $(document).width() >= 1024 ) {
    $(".main_menu_item_li.lvl_1:not(.nav_width_js_NAV)").removeClass("hide");

    var width_Container_Minus = 0;
    var width_Container = $(".main_menu_all").width() - width_Container_Minus;
    var width_Container_2 = 0;
    var width_All_Items = 0;
    var width_Show_Items = 0;
    $(".main_menu_item_li.lvl_1:not(.nav_width_js_NAV)").each( function () {
      width_All_Items = width_All_Items + $(this).width();
    });
    if ( width_Container > width_All_Items ) {
    // ALL NORMAL
    $(".main_menu_item_li.lvl_1:not(.nav_width_js_NAV)").removeClass("hide");
    $(".nav_width_js_NAV").addClass("hide");
  } else {
    // NEED TO COUNT
    $(".main_menu_item_li.lvl_1:not(.nav_width_js_NAV)").each( function () {
      width_Container_2 = width_Container - 56;
      width_Show_Items = width_Show_Items + $(this).width();

      if ( width_Container_2 > width_Show_Items) {
        $(this).addClass("work");
        $(this).removeClass("hide");
      } else {
       $(".main_menu_item_li.lvl_1:not(.nav_width_js_NAV):not(.work)").addClass("hide");
     }
   });
    // $(".nav_width_js_MORE").removeClass("hide");
  }


  $(".main_menu_item_li.lvl_1").removeClass("work");
  } // if width
} // End

// main_menu_width ();
$(window).resize(function() {   
  // main_menu_width ();  
  // setTimeout(function() { main_menu_width (); }, 500);
});


// $("body").on("click", ".nav_width_js_MORE", function () {
//   $(".main_menu_item_li.lvl_1.hide:not(.nav_width_js_NAV)").addClass("work");
//   $(".main_menu_item_li.lvl_1:not(.nav_width_js_NAV)").addClass("hide");
//   $(".main_menu_item_li.lvl_1.work:not(.nav_width_js_NAV)").removeClass("hide");
//   $(".main_menu_item_li.lvl_1:not(.nav_width_js_NAV)").removeClass("work");
//   $(".nav_width_js_MORE").addClass("hide");
//   $(".nav_width_js_BACK").removeClass("hide");
// });
// $("body").on("click", ".nav_width_js_BACK", function () {
//   $(".main_menu_item_li.lvl_1.hide:not(.nav_width_js_NAV)").addClass("work");
//   $(".main_menu_item_li.lvl_1:not(.nav_width_js_NAV)").addClass("hide");
//   $(".main_menu_item_li.lvl_1.work:not(.nav_width_js_NAV)").removeClass("hide");
//   $(".main_menu_item_li.lvl_1:not(.nav_width_js_NAV)").removeClass("work");
//   $(".nav_width_js_BACK").addClass("hide");
//   $(".nav_width_js_MORE").removeClass("hide");
// });














// ===============================================================
// ========================  FORM - PHONE  =============================
// ===============================================================
$(".form_item__PHONE_select input[type='tel']").focus( function () {
  var data_val = $(this).val();
  var data_num = "+" + $(this).parents(".form_item__PHONE_select").find(".selected-flag").attr("data-dial-code");
  if ( data_val == '' || data_val == data_num) {
    $(this).val(data_num)
  }
  $(".country-list").hide();
});
$(".form_item__PHONE_select input[type='tel']").blur( function () {
  var data_val = $(this).val();
  var data_num = "+" + $(this).parents(".form_item__PHONE_select").find(".selected-flag").attr("data-dial-code");
  if ( data_val == '' || data_val == data_num) {
    $(this).val("")
  }
});

//
// SELECT FLAG
//
$("body").on("click", ".selected-flag", function () {
 $(this).parents(".form_item__PHONE_select").find(".country-list").toggle();
})
$("body").on("click", ".form_item__PHONE_select .country", function () {
  var data_flag = $(this).find(".iti-flag").attr("class");
  var data_code_num = $(this).attr("data-dial-code");
  var data_code_t = $(this).attr("data-country-code");

  $(this).parents(".form_item__PHONE_select").find(".selected-flag .iti-flag").removeAttr("class").addClass(data_flag);
  $(this).parents(".form_item__PHONE_select").find(".selected-flag").attr("data-dial-code", data_code_num).attr("data-country-code", data_code_t);

  var data_num = "+" + $(this).parents(".form_item__PHONE_select").find(".selected-flag").attr("data-dial-code");
  $(this).parents(".form_item__PHONE_select").find("input[type='tel']").val(data_num).focus();

  $(".country-list").hide();
})



$(document).mouseup(function (e){
  var div = $(".form_item__PHONE_select"); 
  if (!div.is(e.target) 
    && div.has(e.target).length === 0) {
    $(".country-list").hide();
}
});




// CART
$('body').on("keydown", ".form_item__PHONE_select input[type='tel']", function(event) {
  return ValidateNumericInput(event);
});





// ===============================================================
// ========================  LANDING DIVIDER - read more  =============================
// ===============================================================
$("body").on("click", ".landing_section_divider_text_box_read_more", function () {
  var var_this = $(this).parents(".landing_section_divider_text_box_all");
  var var_height =  var_this.find(".landing_section_divider_text_box_over_height").height();
  var_this.find(".landing_section_divider_text_box_over").css("max-height", var_height);
  var_this.find(".landing_section_divider_text_box_read_more").css("opacity", 0);
  var_this.find(".landing_section_divider_text_box_read_more").slideUp();

  setTimeout(function() { var_this.find(".landing_section_divider_text_box_over").css("max-height", "none"); }, 500);
});






/*
==============================================
        Anouncement Slider
==============================================
*/

$('.anouncement__slider_js').on('init', function(event, slick){
  $('.anouncement__slider_all').addClass("ready");
});

$('.anouncement__slider_js').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  centerMode: true,
  focusOnSelect: true,
  infinite: true,
  autoplay: $('.anouncement__slider_js').attr("data-autoplay"),
  autoplaySpeed: $('.anouncement__slider_js').attr("data-autoplaySpeed")
});

//setTimeout(function() {  $('.anouncement__slider_all').addClass("ready"); }, 2000);











// ===============================================================
// ========================  SEARCH FILTER MOBILE - DRAWER  =============================
// ===============================================================

//
// FILTER
// 
$("body").on('click', '.snize-main-panel-controls', function(e) {
  if ( $(document).width() < 768 ) {
    $('.snize-main-panel-mobile-filters a')[0].click();
    
    
    $(".snize-product-filters-title").addClass("open");
    $(".snize-product-filters-title + .snize-product-filters-list").show();
    $("body").addClass("body_SearctDrawer_filter_CSS");
    setTimeout(function() {  $("body").addClass("body_SearctDrawer_filter"); }, 10);
  }
}); 

$("body").on('click touchstart', '.SearctDrawer_Filter_js__Close', function(e) {
  if ( $(document).width() < 768 ) {
    $('.snize-close-button')[0].click();
    
    $("body").removeClass("body_SearctDrawer_filter");
    setTimeout(function() { $("body").removeClass("body_SearctDrawer_filter_CSS"); }, 300);
  }
}); 
$("body").on('click touchstart', '.snize-product-filters-show-products, .snize-product-filters-reset-all', function(e) {
  if ( $(document).width() < 768 ) {
    setTimeout(function() { $('.SearctDrawer_Filter_js__Close')[0].click(); }, 500);
    
  }
}); 
$("html").on('click touchstart', '.body_SearctDrawer_filter .snize-modal-content:not(.snize-filter-opened) span.snize-product-filters-title', function(e) {
  $('.SearctDrawer_Filter_js__Close')[0].click();
}); 
  

//
// SORT 
//
$("body").on('click', '.snize-main-panel-view-mode', function(e) {
  if ( $(document).width() < 768 ) {
    $("body").addClass("body_SearctDrawer_sort_CSS");
    setTimeout(function() {  $("body").addClass("body_SearctDrawer_sort"); }, 10);
  }
}); 

$("body").on('click touchstart', '.SearctDrawer_Sort_js__Close', function(e) {
  if ( $(document).width() < 768 ) {
    $("body").removeClass("body_SearctDrawer_sort");
    setTimeout(function() { $("body").removeClass("body_SearctDrawer_sort_CSS"); }, 300);
  }
}); 











// ===============================================================
// ========================  VIEWED PRODUCTS  =============================
// ===============================================================

function func_viewed_products () {
  var product_json = {};
  var product_json = $(".product_json").text();
  product_json = JSON.parse(product_json);

  var data_product = {
    "id":product_json.id,
    "title": $(".product_title").text().trim(),
    "available":product_json.available,
    "sold_out": $(".product_info_all .coll_Sold_Out_t ").text(),
    "handle": product_json.handle,
    "href": "/products/"+product_json.handle,
    "img_src": product_json.featured_image,
    "img_fastcart": $(".product_json").attr("data-image"),
    "t_add_to_cart": $(".prod_add_Cart__button").text().trim(),
    "t_thank_you": $(".prod_add_Cart__thank_you").text().trim(),  
    "href_wishlist": $(".productitem_add_wishlist > a").attr("href"),  
  };

  var product_json_variants_check = true;
  $.each( product_json.variants , function(index, value) {
    if (product_json_variants_check && value.available) {
      data_product.variant_id = value.id;
      data_product.price = value.price;
      data_product.price_sale = value.compare_at_price;
      data_product.data_quantity = $("#ProductSelect-product-template[data-prod_id="+product_json.id+"] option[data-id="+value.id+"]").attr("data-qty");

      product_json_variants_check = false;
    }
  }); 

  if ( localStorage.getItem('viewed_products') == null ) {
    data_product = "["+JSON.stringify(data_product)+"]"
    localStorage.setItem('viewed_products', data_product);
  } else {  
    var localStorage_viewed_products = localStorage.getItem('viewed_products');
    localStorage_viewed_products = JSON.parse(localStorage_viewed_products);   
    var each_v_check_id = true;
    $.each( localStorage_viewed_products , function(index2, value2) {
      if ( value2.id == data_product.id ) {
        each_v_check_id = false
      } 
    }); 
    if ( localStorage_viewed_products.length >= 12  ) {
      localStorage_viewed_products.shift();
    } 
    if ( each_v_check_id ) {
      localStorage_viewed_products.push(data_product);
      localStorage.setItem('viewed_products', JSON.stringify(localStorage_viewed_products)); 
    }
  }



}
if ( $("body").hasClass("template-product") ) {
  func_viewed_products ();
}



if ( $(".viewes_prod_all_js").length > 0 && localStorage.getItem('viewed_products') != null ) {
  func_viewed_products_show ();
} else {
    $('.viewes_prod_all_js').hide();
}
function func_viewed_products_show () {



  var data_json = localStorage.getItem('viewed_products');
  data_json = JSON.parse(data_json);


  $.each( data_json, function(index, value) {

    var data_html = '<div class="prod_carousel_item ll_Sold_Out_1_ll" style="width: 100%; display: inline-block;">'+
    '<div class="coll_product_item ll_Sold_Out_2_ll">'+
    '<div class="grid-view-item product-card">'+
    '<a class="grid-view-item__link grid-view-item__image-container full-width-link" href="ll_href_ll" tabindex="0"></a>'+
    '<style>'+
    '@media screen and (min-width: 750px) { '+
    '#ProductCardImage-landing_main-ll_data_id_ll {max-width: px;max-height: 500.0px;}'+
    '#ProductCardImageWrapper-landing_main-ll_data_id_ll {max-width: px;max-height: 500.0px;}} '+
    '@media screen and (max-width: 749px) {#ProductCardImage-landing_main-ll_data_id_ll {max-width: 750px;max-height: 750px;}#ProductCardImageWrapper-landing_main-ll_data_id_ll {max-width: 750px;}}'+
    '</style>'+
    '<div id="ProductCardImageWrapper-landing_main-ll_data_id_ll" class="grid-view-item__image-wrapper product-card__image-wrapper js">'+
    '<div style="padding-top:100.0%;">'+
    '<img id="ProductCardImage-landing_main-ll_data_id_ll" class="grid-view-item__image lazyautosizes lazyloaded" src="ll_image_ll" data-widths="[180, 360]" data-aspectratio="1.0" data-sizes="auto" alt="" data-srcset="ll_image_ll 180w,ll_image_ll 360w" sizes="270px" srcset="ll_image_ll 180w, ll_image_ll 360w">'+
    '</div>'+
    '</div>'+
    '<noscript><img class="grid-view-item__image" src="ll_image_ll" alt="ll_title_ll" style="max-width: 500.0px;"></noscript>'+
    // '<div class="coll_wishlist_icon_all">'+
    // '<div class="coll_wishlist_icon productitem_add_wishlist_js hide" data-handle="ll_handle_ll">'+
    // '<a href="ll_href_wishlist_ll" class="coll_wishlist_a_noCustomer" tabindex="0"></a>'+
    // '</div>'+
    // '</div>'+
    '<div class="h4 grid-view-item__title" aria-hidden="true">ll_title_ll</div>'+

    'll_price_html_ll'+

    // '<form method="post" action="/cart/add" id="product_form" accept-charset="UTF-8" class="product_form coll_form_js" enctype="multipart/form-data" novalidate="novalidate" data-prod_id="ll_data_id_ll" data-variant_id="ll_data_variant_id_ll" data-quantity="ll_data_quantity_ll" data-v_title="ll_title_ll" data-price="ll_price_ll" data-price_sale="" data-fastcart="ll_fast_cart_ll" data-url="ll_href_ll">'+
    // '<div class="hide">'+
    // '<input type="hidden" name="form_type" value="product" tabindex="0">'+
    // '<input type="hidden" name="utf8" value="✓" tabindex="0"><select name="id" id="ProductSelect-product-template" class="product-form__variants no-js" tabindex="0">'+
    // '<option selected="selected" value="ll_data_variant_id_ll">Default Title</option> '+
    // '</select>'+
    // '</div>'+
    // '<div class="collection_add_Cart_all">'+
    // '<button type="submit" name="add" class="collection_add_Cart collection_add_Cart_js" tabindex="0">'+
    // '<span class="collection_add_Cart__button">ll_t_add_to_cart_ll</span>'+
    // '<span class="collection_add_Cart__bg"></span>'+
    // '<span class="collection_add_Cart__thank_you">ll_t_thank_you_ll</span>'+
    // '</button>'+
    // '</div>'+
    // '</form>'+
    '</div>'+
    '</div>'+
    '</div>';

    var var_price_sale = 'NaN';
    if ( value.price_sale != null ) {
      var_price_sale == value.price_sale;

      // SALE %
      var data_prod_sale = value.price * 100 / value.price_sale;
      data_prod_sale = 100 - data_prod_sale;
      data_prod_sale = Math.round(data_prod_sale);
      data_html = data_html.replace(/ll_price_on_sale_ll/g, 'price--on-sale');
      data_html = data_html.replace(/ll_price_sale_format_ll/g, theme.Currency.formatMoney(value.price_sale, theme.moneyFormat));
    } else {
      data_html = data_html.replace(/ll_price_on_sale_ll/g, '');
      data_html = data_html.replace(/ll_price_sale_format_ll/g, theme.Currency.formatMoney(value.price, theme.moneyFormat));
    }

    if ( value.available ) {
      data_html = data_html.replace(/ll_Sold_Out_1_ll/g, '');
      data_html = data_html.replace(/ll_Sold_Out_2_ll/g, '');

    } else {
      data_html = data_html.replace(/ll_Sold_Out_1_ll/g, ' grid-view-item--sold-out coll_product_item__Sold_Out ');
      data_html = data_html.replace(/ll_Sold_Out_2_ll/g, ' grid-view-item--sold-out coll_product_item__Sold_Out ');
    }


    var var_price_html = '<div class="price ll_price_on_sale_ll" data-price data-sold_out_t="'+value.sold_out+'">'+
    '<span class="sale_percent_js">−<span class="data_prod_sale">'+data_prod_sale+'</span> %</span>'+
    '<span class="sale_line">|</span> '+
    '<span class="price-item price-item--regular main_price" data-regular-price data-price="'+value.price+'" data-price-sale="'+var_price_sale+'">'+
    'll_prod_available_ll'+
    '</span>'+
    '<div class="price__sale">'+
    '<span class="price-item price-item--sale main_price" data-sale-price>'+theme.Currency.formatMoney(value.price, theme.moneyFormat)+'</span>'+
    '</div>'+
    '</div>';


    if ( value.price_sale != null ) {
     var_price_html = var_price_html.replace(/ll_price_on_sale_ll/g, 'price--on-sale');
   } else {
     var_price_html = var_price_html.replace(/ll_price_on_sale_ll/g, '');
   }

   if ( value.available == true && value.price_sale != null ) {
      var_price_html = var_price_html.replace(/ll_prod_available_ll/g, theme.Currency.formatMoney(value.price_sale, theme.moneyFormat));
   } else if ( value.available && value.price_sale == null ) {
      var_price_html = var_price_html.replace(/ll_prod_available_ll/g, theme.Currency.formatMoney(value.price, theme.moneyFormat));
   } else {
     var_price_html = var_price_html.replace(/ll_prod_available_ll/g, '<span class="sold_out_t coll_Sold_Out_t">'+value.sold_out+'</span>'); 
   }




   data_html = data_html.replace(/ll_data_id_ll/g, value.id);
   data_html = data_html.replace(/ll_data_variant_id_ll/g, value.variant_id);
   data_html = data_html.replace(/ll_title_ll/g, value.title);
   data_html = data_html.replace(/ll_href_ll/g, value.href);
   data_html = data_html.replace(/ll_href_wishlist_ll/g, value.href_wishlist);
   data_html = data_html.replace(/ll_data_quantity_ll/g, value.data_quantity);
   data_html = data_html.replace(/ll_price_ll/g, value.price);
   data_html = data_html.replace(/ll_price_format_ll/g, theme.Currency.formatMoney(value.price, theme.moneyFormat));
   data_html = data_html.replace(/ll_price_sale_ll/g, var_price_sale);
   data_html = data_html.replace(/ll_price_sale_num_ll/g, data_prod_sale);
   data_html = data_html.replace(/ll_image_ll/g, value.img_src);
   data_html = data_html.replace(/ll_fast_cart_ll/g, value.img_src);
   data_html = data_html.replace(/ll_handle_ll/g, value.handle);
   data_html = data_html.replace(/ll_sold_out_t_ll/g,  value.sold_out);
   data_html = data_html.replace(/ll_price_html_ll/g,  var_price_html);

   data_html = data_html.replace(/ll_t_add_to_cart_ll/g, value.t_add_to_cart);
   data_html = data_html.replace(/ll_t_thank_you_ll/g, value.t_thank_you);
   $(".viewes_prod_all_js_items").prepend(data_html);



 }); 



var prod_carousel_items_js_1_autoplay = false;
if ( $('.viewes_prod_all_js_items').attr('data-autoplay') == 'true' ) {
  prod_carousel_items_js_1_autoplay = true;
}
$('.viewes_prod_all_js_items').slick({
  dots: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: prod_carousel_items_js_1_autoplay,
  autoplaySpeed: $('.viewes_prod_all_js_items').attr('data-autoplaySpeed'),
  responsive: [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 3
    }
  },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 2
    }
  },
  {
    breakpoint: 370,
    settings: {
      slidesToShow: 1
    }
  }
  ]
});


}












// ===============================================================
// ========================   PRODUCT METAFIELDS SLIDER  =============================
// ===============================================================
var pms_pageDots = false;
if ( $('.prod_metafields_slider').attr('data-pageDots') == 'true' ) {
  pms_pageDots = true;
}
var pms_prevNextButtons = false;
if ( $('.prod_metafields_slider').attr('data-prevNextButtons') == 'true' ) {
  pms_prevNextButtons = true;
}
if ( $('.prod_metafields_slider .item').length > 1 ) {
  $('.prod_metafields_slider').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 65, 
      y2: 50,
      x3: 15
    },
    pageDots: pms_pageDots,
    prevNextButtons: pms_prevNextButtons
  });
} else {
  $('.prod_metafields_slider').addClass('one_item');
}


// ===============================================================
// ========================   s VIDEO BOX  =============================
// ===============================================================
$("body").on('click', '.s_banner_video_all_js .s_icon', function() {
  var var_this = $(this).closest('.s_banner_video_all_js');
  var data_url = var_this.find('.s_video').attr('data-url');
  //var_this.find(".s_video iframe").attr('src', 'https://www.youtube.com/embed/'+data_url+'?rel=0&amp;showinfo=0&autoplay=0');

  var_this.find('.s_video').show();
  var_this.find('.s_image img').fadeOut();
  var_this.find('.s_icon').fadeOut();

  var url = var_this.find('iframe').attr('data-src').replace('&autoplay=1', '');
  var_this.find('iframe')[0].src = url;
  setTimeout(function () {
    var_this.find('iframe')[0].src += "&autoplay=1";
  }.bind(this), 2000);
});






// ===============================================================
// ========================  READ MORE  =============================
// ===============================================================
$('body').on('click', '.product_description_readMore_btn a', function(e) {
  e.preventDefault();
  var height = $('.product_description_readMore_height').height();
  var var_this = $(this).closest('.product_description_readMore');
  var_this.find('.product_description_readMore_btn').hide();
  
  var_this.css('max-height', height);
  var_this.find('.product_description_readLess_btn').show();
  setTimeout(function () {
    var_this.addClass('open');
  }.bind(this), 300);
});
$('body').on('click', '.product_description_readLess_btn a', function(e) {
  e.preventDefault();
  var var_this = $(this).closest('.product_description_readMore');
  var_this.find('.product_description_readLess_btn').hide();
  var_this.removeClass('open');
  
  var_this.css('max-height', '63px');
  setTimeout(function () {
    var_this.find('.product_description_readMore_btn').show();
  }.bind(this), 300);
});



}); // end ready









// ===============================================================
// ========================  flickity arrow center  =============================
// ===============================================================
function flickity_arrow_center () {
  $(".flickity_arrow_center").each( function() {
    var height = $(this).find(".flickity-enabled .flickity_arrow_image_js").outerHeight() / 2;
    $(this).find(".flickity-enabled .flickity-button").css("top", height);
  });
  
}

var width = $(window).width(); 
$(window).resize(function() {
    if ($(window).width()== width) return; 
    width = $(window).width();
    setTimeout(function () {
      flickity_arrow_center ();
    }.bind(this), 500);
});
 
 
jQuery(document).ready(function() {
  setTimeout(function () {
    flickity_arrow_center();
  }.bind(this), 1);

  setTimeout(function () {
    flickity_arrow_center();
  }.bind(this), 3000);

  setTimeout(function () {
    flickity_arrow_center();
  }.bind(this), 5500);
}); // end ready







// ===============================================================
// ========================   PhotoSwipe -PRODUCT PAGE  =============================
// ===============================================================
jQuery(document).ready(function() {
  let html = `<!-- Root element of PhotoSwipe. Must have class pswp. -->
  <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
      <!-- Background of PhotoSwipe. 
          It's a separate element as animating opacity is faster than rgba(). -->
      <div class="pswp__bg"></div>
      <!-- Slides wrapper with overflow:hidden. -->
      <div class="pswp__scroll-wrap">
          <!-- Container that holds slides. 
              PhotoSwipe keeps only 3 of them in the DOM to save memory.
              Don't modify these 3 pswp__item elements, data is added later on. -->
          <div class="pswp__container">
              <div class="pswp__item"></div>
              <div class="pswp__item"></div>
              <div class="pswp__item"></div>
          </div>
          <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
          <div class="pswp__ui pswp__ui--hidden">
              <div class="pswp__top-bar">
                  <!--  Controls are self-explanatory. Order can be changed. -->
                  <div class="pswp__counter"></div>
                  <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                  <button class="pswp__button pswp__button--share" title="Share"></button>
                  <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                  <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                  <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                  <!-- element will get class pswp__preloader--active when preloader is running -->
                  <div class="pswp__preloader">
                      <div class="pswp__preloader__icn">
                        <div class="pswp__preloader__cut">
                          <div class="pswp__preloader__donut"></div>
                        </div>
                      </div>
                  </div>
              </div>
              <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                  <div class="pswp__share-tooltip"></div> 
              </div>
              <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
              <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
              <div class="pswp__caption">
                  <div class="pswp__caption__center"></div>
              </div>
          </div>
      </div>
  </div>`;
  $('body').append(html);




}); // end ready

function init_PhotoSwipe () {
  var pswpElement = document.querySelectorAll('.pswp')[0];



  // define options (if needed)
  var options = {
      // optionName: 'option value'
      
    allowPanToNext:false,
    captionEl:false,
    closeOnScroll:false,
    counterEl:false,
    history:false,
    pinchToClose:false,
    preloaderEl:false,
    //scaleMode:"zoom",
    shareEl:false,
    tapToToggleControls:false,

    //index: 0, 
  };

  // Initializes and opens PhotoSwipe

  $('body').on('click', '.product_gallery_big_item', function(e) {
    if ( !$('.pswp--open').length ) {

      // build items array
      var items = [];
      let el_gallery = $('.product_gallery_big_item');
      if ( $('.quickview_all .product_gallery_big_item').length ) {
        el_gallery = $('.quickview_all .product_gallery_big_item');
      }
      el_gallery.each( function() {
        let size = $(this).attr('data-size').split('x');
        let data = {
          src: $(this).attr('data-img_url'),
          w: size[0],
          h: size[1]
        };
        items.push(data);
      });

        
      var index = Number($(this).attr('data-i'));
      options.index = index;
      
      var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
  }
  });
  //gallery.init();

}
jQuery(document).ready(function() {
  init_PhotoSwipe ();
}); // end ready
  
  
  
  
